import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import CommonImage from '@/components/CommonImage';
import { ReactComponent as GridIcon } from '@/assets/icons/grid.svg';
import { ReactComponent as ListIcon } from '@/assets/icons/single-list.svg';
import MyDashboardActionButtons from '@/features/my-dashborad/components/MyDashboardActionButtons';
import CustomDropdown from '@/components/CustomDropdown';
import { DASHBOARD_TAB_ITEMS, SEARCH_SORTING_OPTIONS } from '@/features/task-configuration/constants';
import Chip from '@/features/filter/Chip';
import SopViewModal from '@/features/task-configuration/components/SopViewModal';
import { isAdmin } from '@/utils/Util';
import { useGetSopByFilterIdQuery } from '@/features/task-configuration/api/taskConfigurationApi';

const MyDashboardTopbar = ({
	searchKey,
	onSearch,
	onSelectPriority,
	selectedPriority,
	selectedPendingTask,
	selectedProducts,
	filterTitle,
	designCount,
	toggleFilter,
	setSelectedProducts,
	selectedViewType,
	setSelectedViewType
}) => {
	const [searchParams, setSearchParams] = useSearchParams();
	const [sopModalOpen, setSopModalOpen] = useState(false);
	const handleBack = () => {
		// Simply update URL to go back to OTHERS_PENDING_TASK tab
		setSearchParams({ tab: DASHBOARD_TAB_ITEMS.OTHERS_PENDING_TASK }, { replace: true });
	};

	const filterId = searchParams.get('filterId');

	const { data: sopDataByFilterId } = useGetSopByFilterIdQuery({ filterId: filterId }, { skip: !filterId });

	const handlePrimarySettings = () => {
		window.open(`/configuration/task?tab=CREATE_LIST&editFilterId=${filterId}`, '_blank');
	};

	//sorting options
	const sortingOptions =
		selectedViewType === 'GRID'
			? SEARCH_SORTING_OPTIONS.filter((option) => option.id != 'REQUEST_WISE')
			: SEARCH_SORTING_OPTIONS;
	return (
		<>
			<div className="top-header my-dashboard-topbar bg-white ">
				<div className="page-title-area">
					<div className="d-flex align-items-center gap-1">
						<button
							className="button text size32 p-0 cursor-pointer"
							onClick={() => {
								handleBack();
							}}
						>
							<CommonImage src="/icons/back-arrow-gray.svg" alt="back" />
						</button>
						<span className="semibold-14 m-0 gray_dark_01">
							{/* Need Sample count hrere */}
							{(filterTitle && decodeURIComponent(filterTitle)) ||
								'Need your sample review'}{' '}
						</span>
						{isAdmin() && (
							<span
								className="regular-14 blue cursor-pointer text-underline ml-1"
								onClick={handlePrimarySettings}
							>
								Edit Filter
							</span>
						)}
					</div>
				</div>
				<div className="filter-container-top my-project-topbar">
					<div className="filter-actions d-flex align-items-center justify-content-between w-100">
						<div className="actions-filter d-flex align-items-center gap-2">
							<div className="filters">
								<div className="filter-toggle cursor-pointer" onClick={() => toggleFilter()}>
									<img src={process.env.PUBLIC_URL + '/icons/filter24.svg'} alt="filter" />
								</div>
								<span className="items-count semibold-14 gray_dark_02 mr-2">
									{designCount || 0} Items
								</span>
								<Chip />
							</div>
							{/* Action Buttons */}
							{selectedProducts?.length > 0 ? (
								<MyDashboardActionButtons
									selectedPendingTask={selectedPendingTask}
									productIdList={selectedProducts}
									setSelectedProducts={setSelectedProducts}
								/>
							) : (
								<></>
							)}
						</div>

						<div className="d-flex justify-content-between pb-1">
							<div className="filter-actions task-dashboard-filter">
								<div className="form-group size32 m-0 search-filter filter-with-animation">
									<div className="with-icon right-icon">
										<input
											type="text"
											placeholder="Search"
											name="searchForStyle"
											autoComplete="off"
											value={searchKey}
											onChange={(e) => onSearch?.(e.target.value)}
										/>
										<span className="right-icon">
											<CommonImage src="/icons/search.png" alt="search" />
										</span>
									</div>
								</div>
								<div className="option transparent-select ml-2">
									<CustomDropdown
										title="Request priority"
										items={sortingOptions}
										onItemClick={(value) => onSelectPriority(value)}
										selectedItem={selectedPriority?.value}
										borderBottom={true}
										borderIndex={3}
									/>
								</div>
								<div className="view-button design-view-sort d-flex align-items-center gap-2 mx-2">
									<div className="grid-icon">
										<GridIcon
											onClick={() => setSelectedViewType('GRID')}
											className={`${selectedViewType === 'GRID' ? 'active' : ''} cursor-pointer`}
										/>
									</div>
									<div className="list-icon">
										<ListIcon
											onClick={() => setSelectedViewType('LIST')}
											className={`list-icon ${selectedViewType === 'LIST' ? 'active' : ''} cursor-pointer`}
										/>
									</div>
								</div>
								{sopDataByFilterId && sopDataByFilterId?.id && (
									<div
										className="option transparent-select ml-2"
										onClick={() => setSopModalOpen(true)}
									>
										<p className="underline cursor-pointer text-underline">SOP</p>
									</div>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
			{sopModalOpen && (
				<SopViewModal
					selectedSopId={filterId}
					open={sopModalOpen}
					onClose={() => setSopModalOpen(false)}
					isFilterId={true}
				/>
			)}
		</>
	);
};

export default MyDashboardTopbar;
